import React, { Component } from "react";
import styles from "./styles.scss";
import CSSModules from "react-css-modules";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import moment from "moment";
import { Search } from "@material-ui/icons";
import { number } from "../../utils";

class TempLine extends Component {
   static defaultProps = {
      containerClass: ""
   };
   static propTypes = {
      maxTemp: PropTypes.number,
      minTemp: PropTypes.number
   };

   constructor(props) {
      super(props);
   }

   shouldComponentUpdate(nextProps) {
      const props = this.props;
      for (var p in nextProps) {
         if (nextProps.hasOwnProperty(p)) {
            if (nextProps[p] !== props[p]) {
               return true;
            }
         }
      }
      return false;
   }

   precise(x, y) {
	   return number.parseNumber(x, y);
   }

   getGradient(siteName, min, max) {
      if(min < 10) {
         if(max < 20) {
            // 2
            return (
               <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
                  <stop offset="0%" stopColor="#53669E" stopOpacity="1" />
                  <stop offset="100%" stopColor="#629E54" stopOpacity="1" />
               </linearGradient>
            );
         } else if(max < 30) {
            // 3
            return (
               <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
                  <stop offset="0%" stopColor="#53669E" stopOpacity="1" />
                  <stop offset="50%" stopColor="#629E54" stopOpacity="1" />
                  <stop offset="100%" stopColor="#FCB530" stopOpacity="1" />
               </linearGradient>
            );
         } else {
            // 4
            return (
               <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
                  <stop offset="0%" stopColor="#53669E" stopOpacity="1" />
                  <stop offset="33%" stopColor="#629E54" stopOpacity="1" />
                  <stop offset="66%" stopColor="#FCB530" stopOpacity="1" />
                  <stop offset="100%" stopColor="#EB604A" stopOpacity="1" />
               </linearGradient>
            );
         }
      } else if(min < 20) {
         if(max < 30) {
            // 2
            return (
               <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
                  <stop offset="0%" stopColor="#629E54" stopOpacity="1" />
                  <stop offset="100%" stopColor="#FCB530" stopOpacity="1" />
               </linearGradient>
            );
         } else {
            // 3
            return (
               <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
                  <stop offset="0%" stopColor="#629E54" stopOpacity="1" />
                  <stop offset="50%" stopColor="#FCB530" stopOpacity="1" />
                  <stop offset="100%" stopColor="#EB604A" stopOpacity="1" />
               </linearGradient>
            );
         }
      } else if(min < 30) {
         // 2
         return (
            <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
               <stop offset="0%" stopColor="#FCB530" stopOpacity="1" />
               <stop offset="100%" stopColor="#EB604A" stopOpacity="1" />
            </linearGradient>
         );
      } else {
         // 2
         return (
            <linearGradient gradientUnits="userSpaceOnUse" id={siteName + "_Grad"} x1="0" y1="10" x2="100" y2="10">
               <stop offset="0%" stopColor="#EB604A" stopOpacity="1" />
               <stop offset="100%" stopColor="#AD2F1B" stopOpacity="1" />
            </linearGradient>
         );
      }
   }

   render() {
      if (isNaN(this.props.minTemp) || isNaN(this.props.maxTemp)) {
         return null;
      }

      let min = this.props.minTemp < this.props.totalMinTemp ? this.props.totalMinTemp : this.props.minTemp;
      if(min > this.props.totalMaxTemp) {
         min = this.props.totalMaxTemp - 0.5;
      }
      let max = this.props.maxTemp > this.props.totalMaxTemp ? this.props.totalMaxTemp : this.props.maxTemp;
      if(max < this.props.totalMinTemp) {
         max = this.props.totalMinTemp + 0.5;
      }

      const minPerc = (min - this.props.totalMinTemp) / (this.props.totalMaxTemp - this.props.totalMinTemp);
      const maxPerc = (max - this.props.totalMinTemp) / (this.props.totalMaxTemp - this.props.totalMinTemp);

      let minX = minPerc * 100;
      let maxX = maxPerc * 100;
      if(isNaN(minX)) {
         minX = -10;
      }
      if(isNaN(maxX)) {
         maxX = -10;
      }


      return (
         <div styleName={`_container ${this.props.containerClass}`}>
            <div styleName="text" left="true">{this.precise(this.props.minTemp, 1)}</div>
            <div styleName="_inner">
               <svg width="100%" viewBox={`0 0 100 20`} xmlns="http://www.w3.org/2000/svg">
                  {
                     this.getGradient(this.props.siteName, this.props.totalMinTemp, this.props.totalMaxTemp)
                  }
                  <path d="M0 10 L100 10" stroke="#ECECEC" strokeWidth={1} />
                  <path d={`M${minX} 10 L${maxX || 0} 10`} stroke={"url(#" + this.props.siteName + "_Grad)"} strokeWidth={5} strokeLinecap="round" />
               </svg>
            </div>
            <div styleName="text" right="true">{this.precise(this.props.maxTemp, 1)}</div>
         </div>
      );
   }
}

//do this to merge classes
export default class extends Component {
   constructor(props) {
      super(props);
      this.state = {
         wrapped: null
      };
   }

   componentWillMount() {
      this.setState({
         wrapped: CSSModules(
            TempLine,
            { ...styles, ...this.props.classes },
            {
               allowMultiple: true
            }
         )
      });
   }

   render() {
      const Elem = this.state.wrapped;
      return <Elem {...this.props} />;
   }
}



// WEBPACK FOOTER //
// ./src/components/TempLine/TempLine.js